import { OnboardingStatus } from 'src/context/types';

export type WizardStep = 'profile' | 'organization' | 'restaurant' | 'branch' | 'invite' | 'done';

export const WIZARD_STEPS: WizardStep[] = ['profile', 'organization', 'restaurant', 'branch', 'invite'];

/**
 * Derived from the server on every render — the wizard has no client-side progress state,
 * which is what makes it resumable across devices and reloads.
 */
export function currentStep(status: OnboardingStatus, profileComplete: boolean): WizardStep {
  if (status.hasBranch) return 'invite';
  if (status.hasRestaurant) return 'branch';
  if (status.hasOrg) return 'restaurant';
  if (!profileComplete) return 'profile';
  return 'organization';
}
